import { Input, Modal, Table, TableColumnsType } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { Id, Topup } from 'types'
import style from 'assets/css/Table.module.css'
import { Link } from 'react-router-dom'
import CustomTag from 'components/Buttons/Tag/CustomTag'
import AddButton from 'components/Buttons/Add/AddButton'
import { SearchOutlined } from '@ant-design/icons'
import axiosClient from 'axios-client'
import TableOptions from 'components/Table/TableOptions'
import { updateObject } from 'utils/updateObjectList'
import TopupView from './TopupView'

const TopupList: React.FC = () => {

  const columns: TableColumnsType<Topup> = [
    {
      title: 'Reference',
      dataIndex: 'reference',
      key: 'reference',
      render: (_, record) => <span onClick={()=> handleTopupView(record)}>{record.reference}</span>
    },
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
      render: (_, { client, account }) =>
        client?.id ? (
          <Link
            className={style.title}
            to={account ? '/accounts/view/' + account.id : '/clients/view/' + client.id}
          >
            {client.name} {account && <>({account.username})</>}
          </Link>
        ) : (
          <></>
        ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: amount => <>${amount}</>,
    },
    {
      title: 'Method',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Proof',
      dataIndex: 'proof',
      key: 'proof',
      render: proof => (
        <CustomTag>
          <Link to={proof}>View proof</Link>
        </CustomTag>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => <CustomTag>{status}</CustomTag>,
    },
  ]

  const [topups, setTopups] = useState<Topup[]>([])
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')

  // TopUp View
  const [showTopup, setShowTopup] = useState(false)
  const [selectedTopup, setSelectedTopup] = useState<Topup>()
  const [confirmLoading, setConfirmLoading] = useState(false)
  
  const handleTopupView = (topup: Topup) => {
    setSelectedTopup(topup)
    setShowTopup(true)
  }
  const handleCancel = () => {
    setShowTopup(false)
  }

  const getTopups = () => {
    setLoading(true)

    axiosClient
      .get('/topups', {
        params: {
          search: search,
        },
      })
      .then(({ data }) => {
        console.log('re')
        setTopups(data)
      }).finally(() => setLoading(false))
  }

  const [selectedTopups, setSelectedTopups] = useState<Id[]>([])

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedTopups(selectedRowKeys as Id[])
    },
  }

  const updateTopupsStatus = (field: string, newStatus: string) => {
    // Find the account by its ID
    const updatedAccounts = updateObject<Topup>({
      objects: topups,
      selectedIds: selectedTopups,
      updateProperty: field,
      updateValue: newStatus,
    })

    // Update the state with the modified accounts array
    setTopups(updatedAccounts)
  }

  useEffect(() => {
    getTopups()
  }, [])

  return (
    <>
      <div className={style.page_title}>
        <div className={style.label}>Accounts</div>
        <div className={style.count}>{topups?.length} Accounts</div>
      </div>
      <div className={style.box}>
        <Input
          onChange={ev => setSearch(ev.currentTarget.value)}
          addonBefore={<SearchOutlined />}
          placeholder="large size"
        />
        <button onClick={getTopups}> search </button>
        <Table
          columns={columns}
          dataSource={topups}
          rowSelection={{
            type: 'checkbox',
            fixed: true,
            ...rowSelection,
          }}
          pagination={{
            position: ['bottomCenter'],
            pageSizeOptions: [10, 20, 50],
            showSizeChanger: true,
          }}
          loading={loading}
          rowKey={record => record.id}
          className={`${style.antTable}`}
          rowClassName={`${style.antRow}`}
          bordered
        />
      </div>

      <Modal
      width={1000}
      title="Top up account"
      open={showTopup}
      onCancel={handleCancel}
      footer={null}
      >
        <TopupView topup={selectedTopup}/>
      </Modal>
    </>
  )
}

export default TopupList
